import { GridSelectionModel } from '@mui/x-data-grid-pro';

export type Action = 'delete' | 'update' | 'create';

export type ActionHandler = (action: Action, selection: GridSelectionModel) => void;

export const SINGLE_SELECTION_ACTIONS: Action[] = ['delete', 'update'];

export function getEnabledActions(selection: GridSelectionModel): Action[] {
  switch (selection.length) {
    case 0:
      return [];
    case 1:
      return SINGLE_SELECTION_ACTIONS;
    default:
      return ['delete'];
  }
}
